export const FETCH_USER = 'fetch_user';
export const FETCH_NEWSLETTERS = 'fetch_newsletters';
export const FETCH_PAGES = 'fetch_pages';
export const FETCH_PAGE = 'fetch_page';